import { useState, useEffect } from "react";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";

function countdown(remindAt) {
  const diff = new Date(remindAt) - Date.now();
  if (diff <= 0) return "now!";
  const m = Math.floor(diff / 60000);
  const h = Math.floor(m / 60);
  const dd = Math.floor(h / 24);
  if (dd > 0) return `in ${dd}d ${h % 24}h`;
  if (h > 0) return `in ${h}h ${m % 60}m`;
  return `in ${m}m`;
}

export default function ReminderCard({ card, onData }) {
  const d = card.data || {};
  const [title, setTitle] = useState(d.title || "");
  const [, tick] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => {
      tick((t) => t + 1);
      if (d.remind_at && !d.done && !d.notified && new Date(d.remind_at) <= Date.now()) {
        toast(`⏰ Reminder: ${d.title || "Untitled"}`, { duration: 10000 });
        onData({ notified: true });
      }
    }, 30000);
    return () => clearInterval(iv);
  }, [d.remind_at, d.done, d.notified, d.title, onData]);

  const due = d.remind_at && new Date(d.remind_at) <= Date.now();

  return (
    <div className="space-y-2">
      <input
        data-testid="reminder-title-input"
        value={title} onChange={(e) => setTitle(e.target.value)}
        onBlur={() => title !== d.title && onData({ title })}
        placeholder="Remind me to..."
        className={`w-full bg-transparent font-display text-base font-bold outline-none placeholder:opacity-40 ${d.done ? "line-through opacity-50" : ""}`}
      />
      <input
        data-testid="reminder-datetime-input"
        type="datetime-local" value={d.remind_at || ""}
        onChange={(e) => onData({ remind_at: e.target.value, notified: false })}
        className="w-full rounded-lg bg-black/10 dark:bg-white/10 px-2 py-1.5 text-xs outline-none cursor-pointer"
      />
      <div className="flex items-center justify-between">
        {d.remind_at && !d.done && (
          <span className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-mono ${due ? "bg-red-500/20 text-red-600 dark:text-red-300 animate-pulse" : "bg-black/10 dark:bg-white/10"}`}
            data-testid="reminder-countdown">
            <BellRing className="h-3 w-3" /> {countdown(d.remind_at)}
          </span>
        )}
        <button
          data-testid="reminder-done-button"
          onClick={() => onData({ done: !d.done })}
          className={`ml-auto flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold transition-all ${
            d.done ? "bg-green-500/25 text-green-700 dark:text-green-300" : "bg-black/10 dark:bg-white/10 hover:bg-black/20"
          }`}>
          <Check className="h-3 w-3" /> {d.done ? "Done ✦" : "Mark done"}
        </button>
      </div>
    </div>
  );
}
